import React, { useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { closeTooltip, editNote } from "../../../store/actions";

interface IProps {
  note: string;
  type: string;
}

const mapDispatchToProps = (dispatch: any) => ({
  closeTooltipDispatch: () => dispatch(closeTooltip()),
  editNoteDispatch: (type: string, note: string) => dispatch(editNote(type, note))
})

const connector = connect(null, mapDispatchToProps);

const EditNote = ({
  note,
  type,
  closeTooltipDispatch,
  editNoteDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const [editedNote, setEditedNote] = useState<string>(note || "")

  return (<>
    <h3 className="title">Write your message</h3>
    <input
      type="text"
      className="input"
      value={editedNote}
      onChange={e => setEditedNote(e.target.value)}
    />
    <a
      onClick={() => closeTooltipDispatch()}
    >Cancel</a>
    <a
      className={`link pull-right ${editedNote && editedNote.length ? "" : "disabled"}`}
      onClick={() => editedNote && editedNote.length && editNoteDispatch(type, editedNote)}
    >
      Set
    </a>
  </>)
}

export default connector(EditNote);
